import { memo, useRef } from 'react';
import FloatAnimation from './FloatAnimation';
import RainAnimation from './RainAnimation';

interface IconProps {
  className?: string;
}

function LightRainIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-light-rain"
    >
      <path
        d="M55.0684 23C67.2823 23 77.1836 32.9013 77.1836 45.1152C77.1836 45.5608 77.1695 46.0033 77.1436 46.4424H84.3457C93.6283 46.4424 101.154 53.9674 101.154 63.25C101.154 72.5325 93.6282 80.0576 84.3457 80.0576H34.8076C25.5251 80.0576 18.0002 72.5325 18 63.25C18 54.5784 24.5669 47.4402 32.999 46.5381C32.9691 46.0676 32.9531 45.5932 32.9531 45.1152C32.9531 32.9012 42.8544 23 55.0684 23Z"
        fill="white"
        fillOpacity="0.7"
      >
        <FloatAnimation />
      </path>
      <path
        d="M45.1477 76.3516C45.5058 75.6046 46.4017 75.2894 47.1487 75.6475C47.8956 76.0056 48.2108 76.9014 47.8528 77.6484L44.3528 84.9512C43.9947 85.6981 43.0988 86.0133 42.3518 85.6553C41.6049 85.2972 41.2897 84.4013 41.6477 83.6543L45.1477 76.3516Z"
        fill="white"
      >
        <RainAnimation delay={0} />
      </path>
      <path
        d="M60.6477 76.3516C61.0058 75.6046 61.9017 75.2894 62.6487 75.6475C63.3956 76.0056 63.7108 76.9014 63.3528 77.6484L59.8528 84.9512C59.4947 85.6981 58.5988 86.0133 57.8518 85.6553C57.1049 85.2972 56.7897 84.4013 57.1477 83.6543L60.6477 76.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.3} />
      </path>
      <path
        d="M50.1477 87.3516C50.5058 86.6046 51.4017 86.2894 52.1487 86.6475C52.8956 87.0056 53.2108 87.9014 52.8528 88.6484L49.3528 95.9512C48.9947 96.6981 48.0988 97.0133 47.3518 96.6553C46.6049 96.2972 46.2897 95.4013 46.6477 94.6543L50.1477 87.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.6} />
      </path>
      <path
        d="M76.1477 76.3516C76.5058 75.6046 77.4017 75.2894 78.1487 75.6475C78.8956 76.0056 79.2108 76.9014 78.8528 77.6484L75.3528 84.9512C74.9947 85.6981 74.0988 86.0133 73.3518 85.6553C72.6049 85.2972 72.2897 84.4013 72.6477 83.6543L76.1477 76.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.9} />
      </path>
      <path
        d="M65.6477 87.3516C66.0058 86.6046 66.9017 86.2894 67.6487 86.6475C68.3956 87.0056 68.7108 87.9014 68.3528 88.6484L64.8528 95.9512C64.4947 96.6981 63.5988 97.0133 62.8518 96.6553C62.1049 96.2972 61.7897 95.4013 62.1477 94.6543L65.6477 87.3516Z"
        fill="white"
      >
        <RainAnimation delay={1.2} />
      </path>
    </svg>
  );
}

export default memo(LightRainIcon);
